var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 3,
    fill: "#F4F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 15.499V13.999H9.5C8.6735 13.999 8 14.6725 8 15.499V18.499H18.8165C18.608 17.5825 18.5 16.5955 18.5 15.499Z",
    fill: "#5C5F62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9385 21.499C30.9155 23.0755 29.3555 24.4165 27.1205 25.7005C26.777 25.897 26.39 25.999 26 25.999C25.61 25.999 25.223 25.897 24.884 25.7035C22.649 24.4165 21.089 23.074 20.0645 21.499H8V28.999C8 29.827 8.6735 30.499 9.5 30.499H30.5C31.328 30.499 32 29.827 32 28.999V21.499H31.9385ZM14.75 25.999H11.75C11.336 25.999 11 25.663 11 25.249C11 24.835 11.336 24.499 11.75 24.499H14.75C15.164 24.499 15.5 24.835 15.5 25.249C15.5 25.663 15.164 25.999 14.75 25.999Z",
    fill: "#5C5F62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5455 11.8117L26.2955 9.56173C26.105 9.48073 25.8935 9.48073 25.703 9.56173L20.453 11.8117C20.1785 11.9287 20 12.2002 20 12.5002V15.5002C20 19.6267 21.5255 22.0387 25.6265 24.4012C25.742 24.4672 25.871 24.5002 26 24.5002C26.129 24.5002 26.258 24.4672 26.3735 24.4012C30.4745 22.0447 32 19.6327 32 15.5002V12.5002C32 12.2002 31.8215 11.9287 31.5455 11.8117ZM28.8365 15.2197L25.8365 18.9697C25.6925 19.1467 25.4765 19.2502 25.25 19.2502C25.2395 19.2502 25.2275 19.2502 25.2185 19.2502C24.98 19.2397 24.7595 19.1167 24.626 18.9172L23.126 16.6672C22.8965 16.3222 22.9895 15.8572 23.3345 15.6277C23.6765 15.3997 24.143 15.4897 24.374 15.8362L25.3055 17.2327L27.6635 14.2837C27.923 13.9612 28.3955 13.9102 28.718 14.1667C29.042 14.4232 29.093 14.8957 28.8365 15.2197Z",
    fill: "#5C5F62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.bb867585e77accff8c5da0e65715164c.svg";
export { ForwardRef as ReactComponent };